export default "__VITE_ASSET__D0jWM$v4__"